import React, { useState } from 'react';
import './eventProgram.css';

const EventProgram = ({ id, title, photo, photoAlt, paragraphs = [] }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
    setIsClosing(false);
  };

  const closeModal = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsModalOpen(false);
    }, 300); 
  };

  return (
    <section id={id} className="event-program">
      <div className="event-program-content">
        <div className="program-photo" onClick={openModal}>
          <img
            src={photo}
            alt={photoAlt}
          />
        </div>
        <h2>{title}</h2>
        {paragraphs.map((paragraph, index) => <p key={index}>{paragraph}</p>)}
      </div>

      {isModalOpen && (
        <div className={`modal-overlay ${isClosing ? 'closing' : ''}`} onClick={closeModal}>
          <div className={`modal-content ${isClosing ? 'closing' : ''}`} onClick={(e) => e.stopPropagation()}>
            <button className="close-modal" onClick={closeModal}>
              &times;
            </button>
            <img
              src={photo}
              alt={photoAlt}
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default EventProgram;
